<template>
  <div class="d-flex artist-search">
    <div class="autocomplete">
      <form @submit.prevent>
        <base-input
          type="text"
          name="search"
          placeholder="Enter an artist's username"
          @input="onChange"
          v-model="search"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
          spellcheck="false"
          autocomplete="off"
        />
        <ul
          id="autocomplete-results"
          ref="scrollContainer"
          v-show="isOpen"
          class="autocomplete-results"
        >
          <li
            ref="options"
            v-for="(result, i) in results"
            :key="i"
            @click="setResult(result)"
            class="autocomplete-result"
            :class="{ 'is-active': i === arrowCounter }"
          >
            {{ result.handle }}
          </li>
        </ul>
      </form>
    </div>
    <router-link
      :to="artistLink"
      :disabled="!artistLink"
      class="btn btn-secondary"
      >GO</router-link
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "artist-search",
  data() {
    return {
      isOpen: false,
      results: [],
      search: "",
      arrowCounter: 0,
      artistLink: "",
    };
  },
  computed: mapState(["allArtists"]),
  methods: {
    onChange() {
      // Let's warn the parent that a change was made
      this.$emit("input", this.search);
      this.artistLink = "";
      this.filterResults();
      this.isOpen = true;
    },
    filterResults() {
      // first uncapitalize all the things
      this.results = this.allArtists.filter((item) => {
        return (
          item.handle.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
    setResult(result) {
      this.search = result.handle;
      this.artistLink = result.artist_link;
      this.isOpen = false;
      this.onEnter();
    },
    onArrowDown(evt) {
      if (this.arrowCounter < this.results.length - 1) {
        this.arrowCounter = this.arrowCounter + 1;
        this.fixScrolling();
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling();
      }
    },
    fixScrolling() {
      const lineHeight = this.$refs.options[this.arrowCounter].clientHeight;
      this.$refs.scrollContainer.scrollTop = lineHeight * this.arrowCounter;
    },
    onEnter() {
      if (this.isOpen) {
        this.search = this.results[this.arrowCounter].handle;
        this.artistLink = this.results[this.arrowCounter].artist_link;
        this.isOpen = false;
        this.arrowCounter = -1;
        this.$router.push(this.artistLink);
      } else if (!this.isOpen && this.artistLink) {
        this.$router.push(this.artistLink);
      }
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    },
  },
  mounted() {
    this.$store.dispatch("getAllArtists");
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style lang="scss">
.autocomplete {
  position: relative;
  margin-right: 0.25rem;
  width: 250px;

  .form-group {
    margin-bottom: 0;
    .form-control {
      height: 43px;
      background: rgba(255, 255, 255, 0.2);
      color: white;

      &:focus {
        border-color: #11cdef;
      }
    }
  }
}

.autocomplete-results {
  z-index: 1;
  margin: 0;
  padding: 0;
  max-height: 200px;
  overflow: auto;
  width: 100%;
  position: absolute;
  top: 48px;
  background: transparent;
  box-shadow: 0 0 2rem 0 rgba(#000, 0.15);
  border-radius: 3px;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 12px;
  cursor: pointer;
  font-weight: 600;
  background: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #11cdef;
  color: white;
}
</style>
